import { Link } from 'react-router-dom'
import { PARCEIROS_ACCENT, PARCEIROS_CADASTRO_PATH, fieldClass, labelClass } from './parceirosBrand'
import { useParceirosLogin } from './useParceirosLogin'

export function ParceirosLoginForm() {
  const form = useParceirosLogin()

  return (
    <form
      onSubmit={form.submit}
      className='grid gap-4 rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl'
    >
      <div>
        <h2 className='text-lg font-black'>Entrar para indicar</h2>
        <p className='mt-1 text-sm text-white/60'>
          {form.step === 'credentials'
            ? 'Use o e-mail e a senha do cadastro de parceiro.'
            : 'Enviamos um código para o e-mail do cadastro.'}
        </p>
      </div>

      <label className='grid gap-1.5'>
        <span className={labelClass}>E-mail</span>
        <input
          className={fieldClass}
          type='email'
          value={form.email}
          onChange={(e) => form.setEmail(e.target.value)}
          required
          autoComplete='email'
        />
      </label>

      {form.step === 'credentials' ? (
        <label className='grid gap-1.5'>
          <span className={labelClass}>Senha</span>
          <input
            className={fieldClass}
            type='password'
            value={form.password}
            onChange={(e) => form.setPassword(e.target.value)}
            required
            autoComplete='current-password'
          />
        </label>
      ) : (
        <label className='grid gap-1.5'>
          <span className={labelClass}>Código</span>
          <input
            className={fieldClass}
            value={form.code}
            onChange={(e) => form.setCode(e.target.value)}
            required
            minLength={8}
            maxLength={16}
            autoComplete='one-time-code'
          />
        </label>
      )}

      {form.message && <p className='text-sm text-white/70'>{form.message}</p>}
      {form.error && <p className='text-sm text-red-300'>{form.error}</p>}

      <button
        type='submit'
        disabled={form.submitting}
        className='rounded-full px-5 py-3 text-sm font-medium text-white active:scale-95 disabled:opacity-50'
        style={{ background: PARCEIROS_ACCENT }}
      >
        {form.submitting ? 'Aguarde…' : form.step === 'credentials' ? 'Entrar' : 'Validar código'}
      </button>

      <p className='text-sm text-white/55'>
        Ainda não é parceiro?{' '}
        <Link to={PARCEIROS_CADASTRO_PATH} className='text-white underline-offset-2 hover:underline'>
          Quero indicar clientes
        </Link>
      </p>
    </form>
  )
}
